import React from 'react';
import PageContent from '../../components/ContentPage/Index';
import AppBar from '../../components/AppBar/Index';

export default function Index() {
  return (
    <>
      <AppBar pageName="Do'a" />
      <PageContent>
        <h1>Doa</h1>
      </PageContent>
    </>
  );
}
